import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { GoogleLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { setUser } = useAuth();

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            toast.success(`Welcome back, ${data.user.name}`);
            const target =
                data.user.role === "admin"
                    ? "/admin"
                    : data.user.role === "advertiser"
                        ? "/advertiser"
                        : "/respondent";
            navigate(target, { replace: true });
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-6 py-16">
                <p className="eyebrow mb-2">SIGN IN</p>
                <h1 className="h2 mb-2" data-testid="login-headline">Welcome back.</h1>
                <p className="text-ink-600 mb-8 text-sm">
                    No account?{" "}
                    <Link to="/register" className="underline" data-testid="login-to-register-link">
                        Create one — free.
                    </Link>
                </p>

                <button
                    type="button"
                    onClick={googleLogin}
                    className="btn btn-outline w-full mb-4"
                    data-testid="google-login-btn"
                >
                    <GoogleLogo size={18} weight="bold" /> Continue with Google
                </button>

                <div className="flex items-center gap-3 my-6">
                    <div className="flex-1 border-t border-ink-200" />
                    <span className="font-mono text-[10px] text-ink-600">OR</span>
                    <div className="flex-1 border-t border-ink-200" />
                </div>

                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <label className="eyebrow block mb-2">Email</label>
                        <input
                            className="input-base"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@email.com"
                            required
                            data-testid="login-email-input"
                        />
                    </div>
                    <div>
                        <label className="eyebrow block mb-2">Password</label>
                        <input
                            className="input-base"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                            data-testid="login-password-input"
                        />
                    </div>
                    {error && (
                        <div className="bg-error/10 border border-error/40 text-error text-sm px-4 py-3" data-testid="login-error">
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn btn-ink w-full"
                        data-testid="login-submit-btn"
                    >
                        <EnvelopeSimple size={18} /> {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
            <Footer />
        </div>
    );
}
